import { MasterDialog } from "#common/Dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { platformPost } from "#training/services/Api"
import { TextField } from "@mui/material"
import { useCallback, useMemo, useState } from "react"

export function CourseDialogPlataforma(props) {
	const { open, setOpen, setActualizar } = props
	const [description, setDescription] = useState("")

	const handlerClose = useCallback(() => {
		setOpen(false)
		setDescription("")
	}, [setOpen])

	const success = useCallback(() => {
		handlerClose()
		setActualizar((old) => !old)
	}, [handlerClose, setActualizar])

	const { fetch, cancelar } = useApiSend(platformPost, { success })

	const buttons = useMemo(() => {
		return [
			{
				label: "Cancelar",
				onClick: () => {
					cancelar()
					handlerClose()
				},
			},
			{
				label: "Aceptar",
				onClick: () => {
					fetch({ description })
				},
			},
		]
	}, [cancelar, handlerClose, fetch, description])

	return (
		<MasterDialog
			title={"Nueva plataforma"}
			open={open}
			setOpen={setOpen}
			buttons={buttons}
			closeDialog={handlerClose}
		>
			<TextField
				label="Nombre plataforma"
				value={description}
				onChange={(event) => {
					setDescription(event.target.value)
				}}
				fullWidth
			/>
		</MasterDialog>
	)
}
